import axios from 'axios';
import { useConfigHelper } from '@ilteducation/config';
import { Content, ContentType } from '@ilteducation/content-registry-types';

const { getApiUrl } = useConfigHelper();

export default {
  async apiGetById<C extends Content>(id: string) {
    return axios.get(`${getApiUrl('content-registry', true)}/${id}`).then((response) => response.data as C);
  },

  async apiGetByIds<C extends Content>(ids: string[], type: ContentType) {
    const entity = type.toLowerCase();
    return axios
      .get(`${getApiUrl('content-registry', true)}/${entity}/ids=${ids.join(',')}`)
      .then((response) => response.data as C[]);
  },

  async apiGetContentDownloadUrl(id: string, fileName?: string) {
    const cleanedFileName = fileName ? fileName.replace(/[\\/:*?"<>|,]/g, '_') : undefined;
    return axios
      .get(
        `${getApiUrl('content-registry', true)}/${id}/contentUrls${
          cleanedFileName ? `?downloadName=${encodeURI(cleanedFileName)}` : ''
        }`,
      )
      .then((response) => `${response.data.url}` as string);
  },
};
